export default "__VITE_ASSET__BAy0Euaj__"